import { BASE_URL } from "@/utils/Constants";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useEffect, useState } from "react";

export const useGetRecordBaseOnSortingId = (sorting_id: string) => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken

    const [data, setData] = useState<any>(null); // Store the record data
    const [error, setError] = useState<string | null>(null); // Store error messages
    const [loading, setLoading] = useState<boolean>(true); // Store loading state

    useEffect(() => {
        // Early exit if sorting_id or idToken is not provided
        if (!sorting_id || !idToken) return;

        const fetchRecord = async () => {
            try {
                setLoading(true); // Set loading to true before the request

                const response = await fetch(`${BASE_URL}/api/airtable/sorting-lookup/${sorting_id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${idToken}`,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();

                if (!response.ok) {
                    setError(result.detail || 'An error occurred while fetching the record.');
                    setData(null);
                } else {
                    setData(result.record); // Store the retrieved record
                    setError(null); // Clear any previous errors
                }
            } catch (err) {
                console.error("Error fetching record:", err);
                setError('Unexpected error occurred while fetching the record');
                setData(null);
            } finally {
                setLoading(false); // Set loading to false once the request is done
            }
        };

        fetchRecord(); // Call the function to fetch data when component is mounted

    }, [sorting_id, idToken]); // Dependency array to re-run when sorting_id or idToken changes

    return { data, error, loading };
}